import sectionTrustBadgeCss from '../css-snippets/section-trust-badge';

const html = `
<style>${sectionTrustBadgeCss}</style>
<div
  data-attribute="trust-badge-section"
  style="
    --padding-top-desktop: 4px;
    --padding-bottom-desktop: 4px;
    --padding-top-mobile: 4px;
    --padding-bottom-mobile: 4px;
    --background-color: #ffffff;
    --container-background-color: #ffffff;
    --trust-badge-score-bg-color: #f5f5f5;
    --trust-badge-score-color: #000000;
    --border-color: #e0e0e0;
  "
>
  <div class="trust-badge-card">
    <div class="trust-badge-score" data-attribute="trust-badge-score">
      <h2 style="text-align: center;">4.8</h2>
      <p style="text-align: center;">Excellent</p>
    </div>
    <div class="trust-badge-info">
      <div class="trust-badge-brand" data-attribute="brand-content">
        <h2>FurSure</h2>
      </div>
      <div class="trust-badge-images">
        <img
          class="trust-badge-image-1"
          data-attribute="trust-image-1"
          src="https://cdn.skyfastimg.com/images/2026/03/25/image-69c3ade46d7857f89b8fd6cd.png?w=400&h=50&q=80"
          alt=""
        />
        <img
          class="trust-badge-image-2"
          data-attribute="trust-image-2"
          src="https://cdn.skyfastimg.com/images/2026/03/25/image-69c3adf8174d981214cf461a.png?w=400&h=50&q=80"
          alt=""
        />
        <img
          class="trust-badge-image-3"
          data-attribute="trust-image-3"
          src="https://cdn.skyfastimg.com/images/2026/03/25/image-69c3ae13981a475ffb14baa1.png?w=400&h=50&q=80"
          alt=""
        />
      </div>
    </div>
  </div>
</div>
`;
export default html;
